import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Loading from '../Loading';
import PanelHeader from '../PanelHeader/PanelHeader';

const PanelLayout = ({
    children,
    title,
    onClose, // is required only of title is provided
    titleMarginBottom = 12, // is required only of title is provided
    customPaddings = 'px-4 pt-4 pb-5 md:pb-8 sm:px-8',
    renderButtonsGroup = () => {},
    isLoading = false,
}) => {
    const containerClassName = classNames(
        'flex flex-col max-w-full max-h-full h-full',
        customPaddings
    );

    const childrenStyle = title ? { paddingTop: `${Math.max(titleMarginBottom, 0)}px` } : {};

    if (isLoading) {
        return (
            <div className="h-full w-full flex items-center justify-center">
                <Loading />
            </div>
        );
    }

    return (
        <div className={containerClassName}>
            {title && (
                <div className="px-[1px]">
                    <PanelHeader title={title} onClose={onClose} />
                </div>
            )}

            <div
                className="flex-1 overflow-y-auto hide-scrollbar pb-5 pt-1 px-[1px]"
                style={childrenStyle}
            >
                {children}
            </div>

            <div className="pt-3 border-t-1 border-neutral-200 bg-white px-[1px]">
                {renderButtonsGroup()}
            </div>
        </div>
    );
};

PanelLayout.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    onClose: PropTypes.func,
    titleMarginBottom: PropTypes.number,
    customPaddings: PropTypes.string,
    renderButtonsGroup: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default PanelLayout;
